import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Carousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from 'jquery';
import withAuth from '../components/withAuth';

function Home() {
    const navigate = useNavigate();
    const carouselRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isWalletConnected, setIsWalletConnected] = useState(false);

    useEffect(() => {
        // Check authentication whenever the component mounts
        const isAuthenticated = localStorage.getItem('gallery3_authenticated') === 'true';
        if (!isAuthenticated) {
            navigate('/', { replace: true });
        }
        
        // Check if wallet is connected
        const walletConnected = localStorage.getItem('wallet_connected') === 'true';
        setIsWalletConnected(walletConnected);
    }, [navigate]);

    const handleCreateGallery = (e) => {
        e.preventDefault();
        
        if (isWalletConnected) {
            // If wallet is connected, navigate to create gallery
            navigate('/create-gallery');
        } else {
            // If wallet is not connected, simulate connection
            localStorage.setItem('wallet_connected', 'true');
            setIsWalletConnected(true);
            
            // Optional: Show a success message
            alert('Wallet connected! Now you can create your gallery.');
            
            // Navigate to create gallery page
            navigate('/create-gallery');
        }
    };

    const items = [
        {
            text: 'Showcase your art online and in virtual galleries.',
            imageSrc: 'images/carousel/home-1.jpg',
            title: '1',
            by: 'Nicholas Daniels',
            alt: 'Hot Lava',
        },
        {
            text: 'Connect locally and globally.',
            imageSrc: 'images/carousel/home-2.jpg',
            title: '2',
            by: 'Lori Hart',
            alt: 'Loop Donut',
        },
        {
            text: 'Share directly with collectors and enthusiasts.',
            imageSrc: 'images/carousel/home-3.jpg',
            title: '3',
            by: 'Lori Hart',
            alt: 'Loop Donut',
        },
        // {
        //     text: 'Accessible on AR.',
        //     imageSrc: 'images/carousel/Wire-sculpture.gif',
        //     title: '4',
        //     by: 'Artist Name',
        //     alt: 'Accessible AR',
        // },
    ];

    const spans = items.map(item => item.text);

    const carouselOptions = {
        infinite: true,
        speed: 300,
        items: 3,
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        startPosition: activeIndex,
        className: "owl-theme",
        slideBy: 3,
    };
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div class="no-bottom" id="content">
                <div id="top"></div>
                <section id="section-intro" class="pt80 pb80" style={{ backgroundSize: 'cover', position: 'relative', overflow: 'hidden' }}>

                    <div class="container" style={{ backgroundSize: 'cover' }}>
                        <div class="row align-items-center" style={{ backgroundSize: 'cover' }}>
                            <div class="col-md-6" style={{ backgroundSize: 'cover' }}>
                                <h1>NFT marketplaces<br /> for artists and art galleries</h1>
                            </div>
                            <div class="col-md-6" style={{ backgroundSize: 'cover' }}>
                                <p style={{ fontWeight: '500', color: '#222' }}>
                                    Helping artists and art galleries supercharge digital collectibles.<br />
                                    Our ready-made NFT platform is the place where art becomes unique. It brings together collectors, creators and galleries, allowing them to trade and exchange artwork as non-fungible tokens on TON blockchain.{/*<img src="https://fast.artivive.com/assets/themes/marketplace/images/logo_header.svg" />*/}</p>
                                {/*<a href="explore.html" class="btn-main">Join the community</a>*/}
                                <a href="#" onClick={handleCreateGallery} className="cta">
                                    Create your gallery <span aria-hidden="true" className="arrow_right"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <div class='container video'>
                    <div class='row'>
                        <div class=" cont col-sm-12">
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            >
                                <source src="images/gallery-home.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>


                <section id="section-hero" class="no-bottom pt80" aria-label="section" style={{ backgroundSize: 'cover' }}>
                    <div class="container" style={{ backgroundSize: 'cover' }}>
                        <div class="row" style={{ backgroundSize: 'cover' }}>
                            <div class="col-lg-12 mb-sm-30" style={{ backgroundSize: 'cover' }}>
                                <h1>The one art platform behind it all</h1>


                                <h1 className="subhome">
                                    {spans.map((text, index) => (
                                        <span
                                            key={index}
                                            onClick={() => {
                                                setActiveIndex(index);
                                                if (carouselRef.current) {
                                                    carouselRef.current.to(index, 300);
                                                }
                                            }}
                                            className={activeIndex === index ? 'active' : ''}
                                            style={{ cursor: 'pointer', marginRight: '5px' }}
                                        >
                                            {text}
                                        </span>
                                    ))}
                                </h1>    
                            </div>
                        </div>
                    </div>
                </section>



                <section id="section-trending-nfts" class="pt60 no-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                {/*<h1>Featured Collections or Galleries</h1>*/}

                                <div className="home-container">
                                    <div className="carousel-wrapper">

                                        <Carousel key={activeIndex} {...carouselOptions}>
                                            {items.map((item, index) => (
                                                <div className="nft_pic"key={index}>
                                                    <a href="/item">
                                                        <span className="nft_pic_info">
                                                            <span className="nft_pic_title">{item.title}</span>
                                                            <span className="nft_pic_by">{item.by}</span>
                                                        </span>
                                                    </a>
                                                    <div className="nft_pic_wrap" style={{ backgroundSize: 'cover' }}>
                                                        <img src={item.imageSrc} className="lazy img-fluid" alt={item.alt} />
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                <section id="section-intro" class="no-bottom pt80" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>How It Works</h1>
                            </div>



                        </div>
                    </div>
                </section>

                <section id="section-latest-nft" class="pt60 no-bottom" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Your digital art to tokenize on</h1>

                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-latest-nft" class="pt60 no-bottom" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Who can create NFTs</h1>

                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-latest-nft" class="pt60 no-bottom" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>What artwork to turn into NFTs?
                                </h1>

                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-news">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="text-left pb30">
                                    <h1>For everyone from art enthusiasts to serious collectors</h1>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div className="post-image" style={{ backgroundSize: 'cover', position: 'relative' }}>
                                            <img
                                                alt=""
                                                src="https://enftymart.themenio.com/html/images/thumb/nft8.jpg"
                                                className="lazy normal-image"
                                                height="260px"
                                            />
                                            <img
                                                alt=""
                                                src="/images/home-1.jpg" // Replace with your hover image URL
                                                className="lazy hover-image"
                                                height="260px"
                                            />
                                        </div>
                                        <div class="post-text">
                                            {/*<span class="p-date">October 28, 2020</span>*/}
                                            <h4><a href="news-single.html" class="inactive">Get started with your gallery<span></span></a></h4>
                                            <p>Galleries of all sizes can showcase their collections, reach a global audience, and sell pieces directly to art lovers worldwide.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div class="post-image">
                                            <img alt="" src="https://enftymart.themenio.com/html/images/thumb/nft19.jpg" className="lazy normal-image"
                                                height="260px"
                                            />
                                            <img
                                                alt=""
                                                src="/images/home-2.jpg" // Replace with your hover image URL
                                                className="lazy hover-image"
                                                height="260px"
                                            />
                                        </div>
                                        <div class="post-text">
                                            {/*<span class="p-date">October 28, 2020</span>*/}
                                            <h4><a href="news-single.html" class="inactive">Grow as an artist<span></span></a></h4>
                                            <p>Artists can share their vision, display their works, and connect with a community of collectors and enthusiasts who truly value creativity and originality..</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div class="post-image">
                                            <img alt="" src="https://enftymart.themenio.com/html/images/thumb/nft16.jpg" className="lazy normal-image"
                                                height="260px"
                                            />
                                            <img
                                                alt=""
                                                src="/images/home-3.jpg" // Replace with your hover image URL
                                                className="lazy hover-image"
                                                height="260px"
                                            />
                                        </div>
                                        <div class="post-text">
                                            {/*<span class="p-date">October 28, 2020</span>*/}
                                            <h4><a href="news-single.html" class="inactive">Build your collection<span></span></a></h4>
                                            <p>Collectors can explore exclusive pieces, discover emerging artists, and purchase unique artworks that resonate on a personal level, enriching their collections..</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-latest-nft" class="pt60 no-bottom" style={{ borderBottom: "1px solid rgba(200, 200, 200, 0.5)" }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1>Frequently Asked Questions</h1>

                            </div>
                        </div>
                    </div>
                </section>
                <section id="section-intro" class="no-bottom pt80">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 text-center">
                                <h1 style={{ color: 'gray' }}>Got something else in mind? <a href="/contact" style={{ color: '#000' }}>Let's chat</a></h1>
                            </div>
                        </div>
                    </div>
                </section>
            </div >

            <div class="modal fade" id="buy_now" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered de-modal">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="p-3 form-border">
                                <h3>Checkout</h3>
                                You are about to purchase a <b>Diminishable #108</b> from <b>Monica Lucas</b>
                                <div class="spacer-single"></div>
                                <h6>Enter quantity. <span class="id-color-2">10 available</span></h6>
                                <input type="text" name="buy_now_qty" id="buy_now_qty" class="form-control" value="1" />
                                <div class="spacer-single"></div>
                                <div class="de-flex">
                                    <div>Your balance</div>
                                    <div><b>10.67856 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Service fee 2.5%</div>
                                    <div><b>0.00325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>You will pay</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="spacer-single"></div>
                                <a href="wallet.html" target="_blank" class="btn-main btn-fullwidth">Add funds</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="place_a_bid" tabindex="-1" aria-labelledby="place_a_bid" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered de-modal">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="modal-body">
                            <div class="p-3 form-border">
                                <h3>Place a Bid</h3>
                                You are about to place a bid for <b>Diminishable #108</b> from <b>Monica Lucas</b>
                                <div class="spacer-single"></div>
                                <h6>Your bid (ETH)</h6>
                                <input type="text" name="bid_value" id="bid_value" class="form-control" placeholder="Enter bid" />
                                <div class="spacer-single"></div>
                                <h6>Enter quantity. <span class="id-color-2">10 available</span></h6>
                                <input type="text" name="bid_qty" id="bid_qty" class="form-control" value="1" />
                                <div class="spacer-single"></div>
                                <div class="de-flex">
                                    <div>Your bidding balance</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Your balance</div>
                                    <div><b>10.67856 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>Service fee 2.5%</div>
                                    <div><b>0.00325 ETH</b></div>
                                </div>
                                <div class="de-flex">
                                    <div>You will pay</div>
                                    <div><b>0.013325 ETH</b></div>
                                </div>
                                <div class="spacer-single"></div>
                                <a href="wallet.html" target="_blank" class="btn-main btn-fullwidth">Place a bid</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer component */}
            <Footer />


        </div >
    );
}

export default withAuth(Home);